import React from 'react'
import { createContentVisit } from '../createContentVisit'

export interface TrackedLinkProps {
  eventType: string
  supplierId?: number
  linkClasses?: string
  url?: string
  target?: string
  children?: React.ReactNode
  additionalHandleClick?: () => void
}

const TrackedLink: React.FC<TrackedLinkProps> = ({ eventType, supplierId, linkClasses, url, target, children, additionalHandleClick, ...props }) => {
  const handleClick: React.MouseEventHandler<HTMLAnchorElement> = () => {
    if (additionalHandleClick != null) { additionalHandleClick() }
    void createContentVisit({
      event_type: eventType,
      href: url,
      supplier_id: supplierId
    })
  }

  return (
    <a
      {...props}
      className={linkClasses}
      href={url}
      target={target ?? '_blank'}
      onClick={handleClick}
      data-test-tracked-link
    >
      {children}
    </a>
  )
}

export default TrackedLink
